import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const AdjustWeight = {
  id: 'adjust-weight',
  name: BulkActions.adjustWeight.message,

  makeHandler: (dispatch, dataType) => {
    return (ids, filters) =>
      dispatch(BulkUpdateActions.startBulkUpdateJob(dataType, [BulkActions.adjustWeight], ids, GuidService.newGuid(), filters));
  },
};
